// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".writing-response-panel-container {\n  margin: 10px;\n  height: calc(100% - 66px);\n}\n\n.writing-response-panel-header {\n  color: #004987;\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 30px; \n  font-weight: bold;\n  margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
